import React from 'react';
import { Modal as OmModal, ModalProps } from '@moda/om';
import { getModalShards } from './getModalShards';

export { ModalProps };

export const Modal: React.FC<ModalProps> = ({ shards, ...rest }) => (
  <OmModal shards={[...getModalShards(), ...(shards ?? [])]} {...rest} />
);
